import React from 'react';
import type { FC } from 'react';
import { Alert, Badge, Text, Box } from '@wix/cli-ui-kit';
import { Trans } from '@wix/cli-i18n';
import type { AppData } from '../types.js';

export const AppRegistered: FC<AppData> = ({ appName }) => {
  return (
    <Box marginLeft={-2}>
      <Alert type="success">
        <Badge skin="success">
          <Trans i18nKey="create_app.success" />
        </Badge>{' '}
        <Trans
          i18nKey="create_app.create_new.app_registered_successfully"
          components={[<Text bold />]}
          values={{ appName }}
        />
      </Alert>
    </Box>
  );
};
